import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let BcMask = class BcMask extends Vue {
};
__decorate([
    Prop()
], BcMask.prototype, "props", void 0);
BcMask = __decorate([
    Component({
        name: 'BcMask',
    })
], BcMask);
export default BcMask;
